import { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { GerenciadorPrecos } from '../../../../../@types/GerenciadorPrecos';
import { RootState } from '../../../../../@types/RootState';
import { ContextMenuItem, ContextMenuSeparator } from '../../../../../components';
import { AlertWithTimestamp } from '../../../../../components/AlertWithTimestamp';
import { Exception } from '../../../../../data';
import { selectorDataPointsExhibitionType } from '../../../../../reducers';
import { selectorContextMenu } from '../../../../../reducers/gerenciadorPrecos/contextMenu';
import { UPDATE_GERENCIADOR_DATAPOINT_BY_ID, UpdateGerenciadorDatapointByIdPayload } from '../../../../../reducers/gerenciadorPrecos/datapoints';
import { onSuccessGetDatapointsRevisaoItem, undoEditedDatapoint } from '../../services';
import { CREATE_MODEL_UNDO_DATAPOINT_PRICE_CHANGE } from '../../utils';

type UndoPriceChangesContextMenuProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

type RowData = GerenciadorPrecos.RowData;

const UndoPriceChangesContextMenu = ({ contextMenuDatapoint, datapointsExibitionType, updateDatapointById }: UndoPriceChangesContextMenuProps) => {
  const handleSuccessUndoEditedDatapoint = useCallback((rowData: RowData) => {
    const parsedData = onSuccessGetDatapointsRevisaoItem(rowData);

    const { productsToBePricedId } = parsedData;

    const payload = {
      id: productsToBePricedId,
      datapointExhibitionType: datapointsExibitionType ?? 'PRODUCT',
      itemsCountFamily: rowData.itemsCountFamily,
      data: parsedData,
    };

    updateDatapointById(payload);

    const { message } = new Exception('Alteração de preço desfeita com sucesso');
    AlertWithTimestamp({ message, type: 'success' });
  }, [datapointsExibitionType, updateDatapointById]);

  const handleUndoEditedDatapoint = useCallback(async () => {
    if (!contextMenuDatapoint) return;

    const model = CREATE_MODEL_UNDO_DATAPOINT_PRICE_CHANGE(contextMenuDatapoint, contextMenuDatapoint.itemsCountFamily ?? 0, datapointsExibitionType);

    try {
      const { status, data } = await undoEditedDatapoint(model);

      if (status !== 200) return;

      handleSuccessUndoEditedDatapoint(data);
    } catch {
      const { message } = new Exception('Erro ao desfazer alteração');
      throw AlertWithTimestamp({ message });
    }
  }, [contextMenuDatapoint, datapointsExibitionType, handleSuccessUndoEditedDatapoint]);

  const isEditedProduct = useMemo(() => {
    if (!contextMenuDatapoint) return false;
    if (contextMenuDatapoint?.priceStatus?.match(/EDITADO/)) return true;
    if (contextMenuDatapoint?.priceStatus?.match(/EDITED/)) return true;
    return false;
  }, [contextMenuDatapoint]);

  return (
    isEditedProduct && (
      <>
        <ContextMenuItem onClick={handleUndoEditedDatapoint}>Desfazer alteração de preço</ContextMenuItem>
        <ContextMenuSeparator />
      </>
    )
  );
};

const mapStateToProps = (state: RootState) => ({
  contextMenuDatapoint: selectorContextMenu(state),
  datapointsExibitionType: selectorDataPointsExhibitionType(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateDatapointById: (payload: UpdateGerenciadorDatapointByIdPayload) => dispatch(UPDATE_GERENCIADOR_DATAPOINT_BY_ID(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UndoPriceChangesContextMenu);
